import React, { Component } from 'react';
import { Button, Descriptions, Input, Row, Space } from 'antd';
import main_styles from '../index.scss';

const { TextArea } = Input;

class NotesTab extends Component {
  render() {
    return (
      <Row>
        <div className="ant-descriptions-title">Add a New Note</div>
        <Space size={'large'} direction={'vertical'}>
          <TextArea rows={6} />
          <Button>Submit</Button>
        </Space>
      </Row>
    );
  }
}

NotesTab.propTypes = {};

export default NotesTab;
